import { IonContent } from "@ionic/react";
import HeaderComponent from "../components/HeaderComponent";
import MapComponent from "../components/MapComponent";

const Tracking: React.FC = () => {
  return (
    <IonContent fullscreen>
      <HeaderComponent title={"Tracking"} />
      <MapComponent />
    </IonContent>
  );
};

export default Tracking;
